import React from "react";

const Admin_Company = () => {
  return <div>Admin_Company</div>;
};

export default Admin_Company;
